(() => {
  if (customElements.get('cf-side-menu')) return;
  customElements.define('cf-side-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const dialog = this.querySelector('dialog'), trigger = this.querySelector('[data-menu-open]');
      trigger.addEventListener('click', () => {dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('cf-menu-is-open');});
      this.querySelector('[data-menu-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }
        if (event.target.closest('a[href^="#"]')) dialog.close();
      });
      dialog.addEventListener('close', () => {trigger.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('cf-menu-is-open'); trigger.focus();});
    }
    disconnectedCallback() { document.documentElement.classList.remove('cf-menu-is-open'); }
  });
})();
